import LegalPage from '../components/LegalPage';
import { disclaimer, site } from '../config';

export default function TermsOfService() {
  return (
    <LegalPage
      title="Terms of Service"
      intro={`By using ${site.domain} and its chat or phone support, you agree to these terms.`}
    >
      <h2>Independent service</h2>
      <p>{disclaimer}</p>

      <h2>What we provide</h2>
      <p>
        We offer guidance and troubleshooting help for Family Tree Maker. We do not sell software licences or
        subscriptions, and we cannot access or change your account with the software publisher.
      </p>

      <h2>Your responsibilities</h2>
      <p>
        You are responsible for keeping backups of your data, for the actions you take on your own computer, and
        for giving accurate information so we can help. Never share passwords with anyone claiming to be support.
      </p>

      <h2>No guarantee</h2>
      <p>
        We work hard to resolve every issue, but some problems depend on the software, your hardware, or third
        parties and may not be fixable. Support is provided “as is”.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        To the extent allowed by law, we are not liable for indirect or consequential losses, including data loss,
        arising from use of this website or our guidance.
      </p>

      <h2>Changes</h2>
      <p>We may update these terms from time to time. The date at the top shows the latest version.</p>
    </LegalPage>
  );
}
